module.exports = __webpack_public_path__ + "img/Ticket _ Claim.505733a0.svg";